<template>
  <b-form id="payment-form">
    <div class="mt-1">
      <label>Card Number</label>
      <div id="card-number"></div>
      <div
        id="card-number-error"
        class="invalid-feedback d-block"
        role="alert"
      ></div>
    </div>

    <b-row class="mt-4">
      <b-col>
        <label>Expiry</label>
        <div id="card-expiry"></div>
        <div
          id="card-expiry-error"
          class="invalid-feedback d-block"
          role="alert"
        ></div>
      </b-col>
      <b-col>
        <label>CVC</label>
        <div id="card-cvc"></div>
        <div
          id="card-cvc-error"
          class="invalid-feedback d-block"
          role="alert"
        ></div>
      </b-col>
    </b-row>

    <div id="card-error" class="invalid-feedback d-block" role="alert"></div>

    <hr class="modal-divider mt-5 mb-4" />

    <div class="text-right mb-3">
      <b-button
        class="btn-action btn-outlined bg-white text-dark mr-3"
        variant="outline-secondary"
        @click="resetForm"
        >Discard</b-button
      >
      <b-button
        class="btn-action"
        variant="primary"
        :disabled="loading"
        @click="createStripeCardToken"
      >
        <b-spinner small v-if="loading"></b-spinner>&nbsp;Save
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      stripe: null,
      element: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null
    }
  },

  methods: {
    ...mapActions({
      createPayment: 'payment/createPayment'
    }),

    resetForm() {
      this.cardNumber.clear()
      this.cardExpiry.clear()
      this.cardCvc.clear()
      this.$emit('onClose')
    },

    createStripeCardToken(e) {
      this.loading = true
      this.stripe
        .createToken(this.cardNumber, this.cardExpiry, this.cardCvc)
        .then(result => {
          if (result.error) {
            if (result.error.type !== 'validation_error') {
              const error = document.getElementById('card-error')
              error.textContent = result.error.message
            }
            this.loading = false
          } else {
            this.submitPaymentDetails(result.token.id)
          }
        })
    },

    async submitPaymentDetails(token) {
      await this.createPayment({ source: token })
      this.loading = false
      this.$emit('onSuccess')
    }
  },

  mounted() {
    this.stripe = window.Stripe(this.$env.stripePublishableKey)
    this.elements = this.stripe.elements()

    // custom style for input fields
    const style = {
      base: {
        fontSize: '18px',
        height: '50px',
        '::placeholder': {
          color: '#ccc'
        }
      }
    }

    // mount card number input field
    this.cardNumber = this.elements.create('cardNumber', { style: style })
    this.cardNumber.mount('#card-number')
    this.cardNumber.on('change', e => {
      const error = document.getElementById('card-number-error')
      error.textContent = e.error ? e.error.message : ''
    })

    // mount card expiry input field
    this.cardExpiry = this.elements.create('cardExpiry', { style: style })
    this.cardExpiry.mount('#card-expiry')
    this.cardExpiry.on('change', e => {
      const error = document.getElementById('card-expiry-error')
      error.textContent = e.error ? e.error.message : ''
    })

    // mount card cvc input field
    this.cardCvc = this.elements.create('cardCvc', { style: style })
    this.cardCvc.mount('#card-cvc')
    this.cardCvc.on('change', e => {
      const error = document.getElementById('card-cvc-error')
      error.textContent = e.error ? e.error.message : ''
    })
  }
}
</script>

<style>
.btn-action {
  min-width: 150px;
}
.StripeElement {
  display: block;
  width: 100%;
  padding: 0.75rem;
  font-size: 18px;
  font-weight: 400;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 8px;
  border: 2px solid #e5e5e5;
  height: 50px;
}
.StripeElement--focus {
  border-color: #2c66d5;
}
.StripeElement--invalid {
  color: #dc3545;
  border-color: #dc3545;
}
</style>
